// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"0a5a40872a791bb6d260","532":"00e3a2f5783431e7ce7d","691":"87c57b37180f32f1889b","954":"cd674e699977d8f35133"}[chunkId] + ".js";
};